import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
} from "@mui/material";
import "./TableChart.css";
import { countries } from "../../utils/constant";
import { formatNumberCommaSeparated } from "../../utils/common";

// Sample Data Array
const graphdata = [
  {
    country: "India",
    emission: 100,
    percentage: 20,
    flag: "https://upload.wikimedia.org/wikipedia/commons/2/2c/India-flag-a4.jpg",
  },
  {
    country: "China",
    emission: 300,
    percentage: 30,
    flag: "https://dm0qx8t0i9gc9.cloudfront.net/thumbnails/video/GTYSdDW/chinese-flag_bygsrmyls_thumbnail-1080_01.png",
  },
  {
    country: "United States",
    emission: 200,
    percentage: 25,
    flag: "https://th.bing.com/th/id/OIP.qIVO5VLgIP2clXu2hCJ08QHaE1?w=267&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7",
  },
  {
    country: "Russia",
    emission: 150,
    percentage: 20,
    flag: "https://th.bing.com/th?id=OIP.uW9Hi1USsULyX2e4Y7iy-gHaE7&w=306&h=204&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
  },
  {
    country: "Brazil",
    emission: 125,
    percentage: 15,
    flag: "https://upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_Brazil.svg",
  },
  // {
  //   name: "Germany",
  //   emission: "98,76,543",
  //   percentage: "11.87%",
  //   flag: "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",
  // },
  // {
  //   name: "Japan",
  //   emission: "87,65,432",
  //   percentage: "10.56%",
  //   flag: "https://upload.wikimedia.org/wikipedia/en/9/9e/Flag_of_Japan.svg",
  // },
  // {
  //   name: "Australia",
  //   emission: "75,43,210",
  //   percentage: "9.08%",
  //   flag: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg",
  // },
  // {
  //   name: "Canada",
  //   emission: "65,43,210",
  //   percentage: "7.87%",
  //   flag: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Canada_%28Pantone%29.svg",
  // },
  // {
  //   name: "UK",
  //   emission: "54,32,109",
  //   percentage: "6.78%",
  //   flag: "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
  // },
];

const TableChart = ({ tableData }) => {
  const [data, setData] = useState([]);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    setData(tableData);
  }, [tableData]);

  const handleSort = (key, order) => {
    setSortKey(key);
    setSortOrder(order);

    const sortedData = [...data].sort((a, b) => {
      const valA = a[key];
      const valB = b[key];

      if (typeof valA === "string") {
        return order === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      return order === "asc" ? valA - valB : valB - valA;
    });

    setData(sortedData);
  };

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      <TableContainer style={{ maxHeight: "300px", overflowY: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  padding: "8px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Country
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={() => handleSort("country", "asc")}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "country" && sortOrder === "asc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={() => handleSort("country", "desc")}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "country" && sortOrder === "desc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell
                style={{
                  padding: "8px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Emission (tCO2e)
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={() => handleSort("emission", "asc")}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "emission" && sortOrder === "asc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={() => handleSort("emission", "desc")}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "emission" && sortOrder === "desc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell
                style={{
                  padding: "8px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Share of World
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={() => handleSort("percentage", "asc")}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "percentage" && sortOrder === "asc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={() => handleSort("percentage", "desc")}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color:
                        sortKey === "percentage" && sortOrder === "desc"
                          ? "black"
                          : "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data?.length > 0 ? (
              data.map((country, index) => {
                const countryData = countries.find(
                  (c) => c.label === country.country
                );
                const isExpanded = expandedRows[index];

                return (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <img
                            src={
                              countryData
                                ? `https://flagcdn.com/w320/${countryData.code.toLowerCase()}.png`
                                : country.flag || ""
                            }
                            alt={`${country.country} Flag`}
                            className="flag-icon"
                            style={{
                              width: "24px",
                              height: "16px",
                              objectFit: "contain",
                            }}
                          />
                          <span>{country.country}</span>
                          {/* <i
                            className={`bi bi-chevron-${
                              isExpanded ? "up" : "down"
                            }`}
                            onClick={() => toggleRow(index)}
                            style={{
                              cursor: "pointer",
                              marginLeft: "8px",
                              fontSize: "14px",
                              color: "#666",
                            }}
                          /> */}
                        </div>
                      </TableCell>
                      <TableCell>
                        {formatNumberCommaSeparated(
                          Number(country.emission?.toFixed(3))
                        ) ?? 0}
                      </TableCell>
                      <TableCell>
                        {country.percentage
                          ? country.percentage.toString().includes(".")
                            ? country.percentage.toString().split(".")[0] +
                              "." +
                              country.percentage
                                .toString()
                                .split(".")[1]
                                .slice(0, 2)
                            : country.percentage
                          : 0}{" "}
                        %
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell style={{ padding: 0 }} colSpan={3}>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <div
                            style={{
                              padding: "4px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "16px",
                                padding: "8px 16px",
                                backgroundColor: "#fff",
                                borderRadius: "4px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              }}
                            >
                              <div style={{ fontWeight: "600" }}>Facility</div>
                              <div style={{ fontWeight: "600" }}>
                                Emission (tCO2e)
                              </div>
                              <div style={{ fontWeight: "600" }}>
                                Percentage
                              </div>
                              <div>Mumbai Facility </div>
                              <div>
                                {formatNumberCommaSeparated(
                                  Number(country.emission?.toFixed(3))
                                ) ?? 0}
                              </div>
                              <div>100 %</div>
                            </div>
                          </div>
                        </Collapse>
                      </TableCell>
                    </TableRow> */}
                  </React.Fragment>
                );
              })
            ) : (
              <TableRow sx={{ width: "100%", height: "100%%" }}>
                <TableCell
                  colSpan={3}
                  sx={{
                    textAlign: "center",
                    padding: "20px",
                    height: "5rem",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    fontSize: "20px",
                    fontFamily: "inter",
                  }}
                >
                  No Data Found
                </TableCell>
                {/* <NoDataFound /> */}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableChart;
